import { render, staticRenderFns } from "./TableRestrictionNumberCell.vue?vue&type=template&id=00b5246a&scoped=true&"
import script from "./TableRestrictionNumberCell.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionNumberCell.vue?vue&type=script&lang=js&"
import style0 from "./TableRestrictionNumberCell.vue?vue&type=style&index=0&id=00b5246a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5246a",
  null
  
)

export default component.exports